// extracted by mini-css-extract-plugin
export default {"wrapper":"KeyIndicators_wrapper__5K4lU","title":"KeyIndicators_title__KwQkO","wrapper_none":"KeyIndicators_wrapper_none__KvzKY"};